module.exports = __webpack_public_path__ + "static/media/hug.9dd0872e.png";